import { ReactNode, useEffect, useRef, useState } from "react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";

import './HorizontalCarousel.css';

gsap.registerPlugin(ScrollTrigger);

const HorizontalCarousel = ({ children, fixTop = false }: { children: ReactNode, fixTop?: boolean }) => {
  const horizontalRef = useRef<HTMLDivElement | null>(null);
  const horizontalContentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (horizontalRef.current === null || horizontalContentRef.current === null) return;
    const section = horizontalContentRef.current;
    const totalWidth = (section?.getBoundingClientRect().width || 0) - window.innerWidth;

    const animation = gsap.to(horizontalRef.current, {
      x: -totalWidth,
      ease: "none",
    });

    const top = fixTop ? 0 : window.innerWidth < 768 ? 60 : 80;

    const trigger = ScrollTrigger.create({
      trigger: horizontalRef.current,
      pin: true,
      scrub: true,
      start: `top ${top}px`,
      end: () => `+=${totalWidth}`,
      animation,
    });

    return () => {
      trigger.kill();
      animation.kill();
    };
  }, [horizontalContentRef, horizontalRef]);

  return (
    <div className="horizontal-carousel" ref={horizontalRef}>
      <div className={`horizontal-carousel-content ${fixTop ? 'fixed-top' : ''}`} ref={horizontalContentRef}>
        {children}
      </div>
    </div>
  );
};

export default HorizontalCarousel;